import React from "react";
import { Box, Typography, Grid, Container, Stack } from "@mui/material";
import { BsListCheck, BsCalendarCheck, BsCheckCircle } from "react-icons/bs";

const steps = [
  {
    title: "Choose your service",
    desc: "Pick the job you need and share details",
    icon: <BsListCheck />,
  },
  {
    title: "Book your time",
    desc: "Select convenient appointment with clear expectations",
    icon: <BsCalendarCheck />,
  },
  {
    title: "Consider it handled",
    desc: "A vetted professional arrives ready",
    icon: <BsCheckCircle />,
  },
];

const HowItWorks = () => {
  return (
    <Box sx={{ backgroundColor: "#fff", py: { xs: 3, md: 5 }, px: { xs: 2, sm: 0 } }}>
      <Container maxWidth="lg">
        <Typography
          sx={{
            fontSize: { xs: "24px", md: "36px" },
            fontWeight: "700",
            color: "#0F2231",
            textAlign: "center",
            mb: { xs: 3, md: 6 },
          }}
        >
          From to-do to done.
        </Typography>

        <Grid container spacing={{ xs: 2.5, md: 4 }} justifyContent="center">
          {steps.map((step, index) => (
            <Grid item key={index} xs={12} sm={4} md={4}>
              <Stack alignItems="center" spacing={{ xs: 4, md: 6 }}>
                <Box
                  sx={{
                    width: { xs: 80, sm: 90, md: 100 },
                    height: { xs: 80, sm: 90, md: 100 },
                    borderRadius: "50%",
                    backgroundColor: "#fff7ed",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#F15A24",
                    fontSize: { xs: "36px", md: "40px" },
                  }}
                >
                  {step.icon}
                </Box>
                <Stack spacing={0.75} alignItems="center">
                  <Typography
                    sx={{
                      fontSize: { xs: "15px", md: "18px" },
                      fontWeight: 700,
                      color: "#0F2231",
                      textAlign: "center",
                    }}
                  >
                    {step.title}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: { xs: "13px", md: "15px" },
                      fontWeight: 400,
                      color: "#5A6772",
                      textAlign: "center",
                      maxWidth: "280px",
                      lineHeight: 1.5,
                    }}
                  >
                    {step.desc}
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default HowItWorks;
